import { render } from "./WhatsNewModal.vue?vue&type=template&id=1943e3d9&scoped=true&ts=true"
import script from "./WhatsNewModal.vue?vue&type=script&lang=ts"
export * from "./WhatsNewModal.vue?vue&type=script&lang=ts"

import "./WhatsNewModal.vue?vue&type=style&index=0&id=1943e3d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1943e3d9"]])

export default __exports__